import React from 'react'

import { Layout } from './Layout'

export const AppRoute = ({ component, ...props }) => {
  const ScreenComponent = component
  return (
    <Layout>
      <ScreenComponent {...props} />
    </Layout>
  )
}
